export function buildDriverChartSeries(results = []) {
  const points = results.map((result) => Number(result?.points || 0))
  const participation = results.map((result) => result?.participated !== false)
  const raced = results.map((result) => result?.raced !== false)

  return {
    pointsData: points.map((value, index) => raced[index] && participation[index] ? value : null),
    dnpData: points.map((value, index) => raced[index] && !participation[index] ? 0 : null),
  }
}

export function buildTeamChartSeries(results = [], participation = null, raceStatuses = null, raced = null) {
  const participationFlags = participation || results.map(() => true)
  const statuses = raceStatuses || results.map(() => 'counting')
  const racedFlags = raced || results.map(() => true)
  const points = results.map((result) => Number(result || 0))

  return {
    pointsData: points.map((value, index) => statuses[index] !== 'rnh' && racedFlags[index] && participationFlags[index] ? value : null),
    dnpData: points.map((value, index) => statuses[index] !== 'rnh' && racedFlags[index] && !participationFlags[index] ? 0 : null),
    rnhData: points.map((value, index) => statuses[index] === 'rnh' ? 0 : null),
  }
}
